// extracted by mini-css-extract-plugin
module.exports = {"description":"CookieModule-module--description--1ECoz","header":"CookieModule-module--header--1PSks","wrapper":"CookieModule-module--wrapper--1jxZh"};